import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getCreditLive = (params) => {
    return axios.get(`${backendHost}/api/admin/limits/live`, {params});
};

export {
    getCreditLive
}